import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "input-group mb-3",
  style: {"font-size":"small","margin-top":"20px"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", {
  style: {"margin-left":"15px","margin-top":"13px"},
  class: "text-gray-600"
}, " Customer Management ", -1)
const _hoisted_3 = { class: "input-group mb-3 col-sm-10 col-sm-6" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("span", {
    class: "input-group-text",
    id: "basic-addon1"
  }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-user fa-sm" })
  ])
], -1)
const _hoisted_5 = { class: "input-group-append" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "fas fa-caret-right fa-sm" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")

  return (_openBlock(), _createBlock("form", {
    class: "form-inline mr-auto w-100 navbar-search search-client",
    style: {"z-index":"99"},
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToOnBehalfOf && _ctx.goToOnBehalfOf(...args)), ["prevent"]))
  }, [
    _createVNode("div", null, [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_AutoComplete, {
            field: "fullName",
            modelValue: _ctx.searchInput,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchInput = $event)),
            suggestions: _ctx.resultsSearch,
            onComplete: _ctx.getFilteredUsers,
            onItemSelect: _ctx.selectCustomer
          }, {
            item: _withCtx((slotProps) => [
              _createVNode("div", null, _toDisplayString(slotProps.item.fullName) + " - " + _toDisplayString(_ctx.hideEmail(slotProps.item.email)), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect"]),
          _createVNode("div", _hoisted_5, [
            _createVNode("button", {
              class: "btn btn-primary",
              type: "button",
              disabled: !_ctx.foundUser,
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.goToOnBehalfOf()), ["prevent"]))
            }, [
              _hoisted_6
            ], 8, ["disabled"])
          ])
        ])
      ])
    ])
  ], 32))
}